import FocusGroups from 'focus_groups/containers';
import VoteFocusGroup from 'focus_groups/containers/vote';
import ViewFocusGroup from 'focus_groups/containers/view';

import FocusGroupResults from 'focus_groups/containers/results';
import FocusGroupSettings from 'focus_groups/containers/settings';
import FocusGroupParticipants from 'focus_groups/containers/participant_list';

import FocusGroupComments from 'focus_groups/containers/comments';
import FocusGroupVotes from 'focus_groups/containers/vote_list';

export {
  VoteFocusGroup, ViewFocusGroup, FocusGroupResults, FocusGroupSettings, FocusGroupParticipants,
  FocusGroupComments, FocusGroupVotes,
};
export default FocusGroups;



// WEBPACK FOOTER //
// ./focus_groups/index.js